import React from 'react'
import Helmet from 'react-helmet'
import favicon from '../images/favicon.ico'
import ComponentRenderer from '../components/ComponentRenderer'
import Layout from '../Layout/Layout'
import SEO from '../components/seo'



const ProductTemplate = ({ pageContext }) => {
  return (
    <Layout>
      <SEO
        title={pageContext.seo.title}
        url={`https://www.mailgun.com/${pageContext.slug}`}
        type="article"
      />
      <Helmet defer={false}>
        <title>{pageContext.seo.title}</title>
        <meta name="description" content={pageContext.seo.description} />
        <meta
          name="robots"
          content={pageContext.seo.robots || 'index,follow'}
        />
        <link rel="canonical" href={pageContext.seo.canonical} />
        <link rel="icon" href={favicon} />
      </Helmet>
      {(pageContext.sections || []).map((section, index) => {
        return (
          <ComponentRenderer
            cmsData={section.fields}
            key={index}
            tag={section.sys.contentType.sys.id}
          >
            {(section.fields.items || []).map(sectionItem => {
              return (
                sectionItem.sys.contentType && (
                  <ComponentRenderer
                    cmsData={sectionItem.fields}
                    tag={sectionItem.sys.contentType.sys.id}
                    key={sectionItem.sys.id}
                  />
                )
              )
            })}
          </ComponentRenderer>
        )
      })}
    </Layout>
  )
}
export default ProductTemplate
